<template>
  <div class="page-wrapper" style="background-color: #f4f6f9">
    <div v-if="!meetingLive">
      <Navbar :image="data.image" :auth="auth" />
    </div>

    <router-view />
    <div v-if="!meetingLive">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
import { useAuth } from "@/stores/auth.js";
import http from "@/services/http";
export default {
  name: "App",
  props: {},
  inject: ["headingMain"],
  components: {
    Navbar,
    Footer,
  },
  data() {
    return {
      request: {
        website: "https://vascularclass.it/",
        slug: "login",
      },
      data: [],
      auth: false,
      path: window.location.pathname,
      meetingLive: false,
    };
  },
  mounted() {
    console.log(this.path);
    if (this.path.includes("/meeting/live/")) {
      this.meetingLive = true;
    }
    const auth = useAuth();
    if (auth.token) {
      this.auth = true;
    }

    this.getImage();
  },
  methods: {
    async getImage() {
      const data = {
        slug: "login",
      };
      await http
        .post("/dinamic-page", data)
        .then((response) => {
          this.data = response.data.data.content[0];
        })
        .catch(function (error) {
          console.log("errore resposnse" + error);
        });
    },
  },
};
</script>

<style>
</style>
